import { useCallback } from "react";
import stencilWeekStore from "../stores/stencilWeekStore";
import { getStencilWeekData } from "../services/stencilWeekService";

export function useStencilWeeks() {
  const { stencilWeeks, setStencilWeeks } = stencilWeekStore();

  const getStencilWeeks = useCallback(async () => {
    try {
      const data = await getStencilWeekData();

      setStencilWeeks(data.stencil_weeks);
      return data;
    } catch (error) {
      console.error(`Failed to load stencils:`, error);
      return [];
    }
  }, [setStencilWeeks]);

  return {
    stencilWeeks,
    setStencilWeeks,
    getStencilWeeks,
  };
}
